<template>
  <Button
    v-if="counting"
    block
    :disabled="true"
    :type="type"
    :class="pointClass"
  >
    {{ countText }} {{ lessTime }}s
  </Button>
  <Button v-else block :type="type" :class="pointClass" @click="countDownEmit">
    <slot></slot>
  </Button>
</template>

<script>
import { EventBus } from '@utiles';
export const START_COUNT_DOWN_EVT = 'startCountDown'; // 开始计时
export const COUNT_DOWN_FINISH = 'countDownFinish'; // 计时结束
export const REET_STATUS = 'resetScountDownStatus'; // 重置计时状态

export default {
  props: {
    countTime: {
      type: Number,
      require: true
    },
    countText: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'primary'
    },
    pointClass: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      counting: false,
      lessTime: 0,
      countDownTimer: null
    };
  },
  mounted() {
    EventBus.$on(START_COUNT_DOWN_EVT, () => {
      this.doCountDown();
    });

    EventBus.$on(REET_STATUS, () => {
      this.reset();
    });
  },
  methods: {
    reset() {
      clearInterval(this.countDownTimer);
      this.counting = false;
    },
    doCountDown() {
      this.lessTime = this.countTime;
      this.counting = true;
      this.countDownTimer = setInterval(() => {
        if (this.lessTime == 0) {
          clearInterval(this.countDownTimer);
          this.counting = false;
          EventBus.$emit(COUNT_DOWN_FINISH);
        }
        this.lessTime--;
      }, 1000);
    },
    countDownEmit() {
      this.$emit('countDown');
    }
  }
};
</script>
